import { render, staticRenderFns } from "./ProductTabsTwo.vue?vue&type=template&id=ca7f10f8&"
import script from "./ProductTabsTwo.vue?vue&type=script&lang=js&"
export * from "./ProductTabsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports